import { withStyles, withTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

class Logo extends React.Component {

    render() {

        const { color, size, style, className, classes, ...props } = this.props
        return (
            <img
                src="/images/icon-shadow.png"
                className={className}
                style={style}
                {...props}/>

        )
    }

}

Logo.propTypes = {
    color: PropTypes.string,
    size: PropTypes.number
}

const styles = theme => ({
    fill0: { fill: 'none' },
    fill1: { fill: theme.palette.secondary.main },
    fill2: { fill: theme.palette.secondary.main, fillRule: 'nonzero' }
})

export default withTheme()(withStyles(styles)(Logo))


// WEBPACK FOOTER //
// ./src/components/common/Logo.js